import React, { FunctionComponent, useMemo } from "react";
import Select from "react-select";
import { ReactSelectOption } from "../../../../../store/onboarding/types";
import { ValueType } from "react-select/src/types";

type OwnProps = {
  skills: ReactSelectOption<string>[];
  value?: string;
  isDisabledOnly?: boolean;
  onChange: (value?: string) => void;
};

type Props = OwnProps;

const ReadingSkillSelector: FunctionComponent<Props> = (props) => {
  const { skills, value, onChange, isDisabledOnly } = props;
  const selectedOption = useMemo(() => {
    if(isDisabledOnly) {
      if(value == 'letter_naming') {
        return skills.find((s) => s.value === 'diag_area_letter_names');
      } else {
        return skills.find((s) => s.value == 'diag_area_'+value);
      }
    } else {
      return skills.find((s) => s.value === value);
    }
  }, [skills, value]);

  const handleReadingSkillChange = (
    value: ValueType<ReactSelectOption<string>, false>
  ) => {
    onChange(value?.value);
  };

  return (
    <Select
      menuPlacement="auto"
      placeholder="Select"
      menuPortalTarget={document.body}
      value={selectedOption}
      options={skills}
      onChange={handleReadingSkillChange}
      styles={{
        menuPortal: (styles) => ({ ...styles, zIndex: 1051 }),
      }}
      isDisabled={isDisabledOnly}
    />
  );
};

export default ReadingSkillSelector;
